import { apiFetch } from './client'
import type { Bracket, Match, Prediction, PredictionInput } from '@/types/bracket'

export const fetchBracket = (token?: string) =>
  apiFetch<Bracket>('/bracket', { token })

export const fetchMatches = () =>
  apiFetch<Match[]>('/matches')

export const fetchMyPredictions = (token: string) =>
  apiFetch<Prediction[]>('/predictions', { token })

export const fetchPlayerPredictions = (playerId: string, token?: string) =>
  apiFetch<Prediction[]>(`/predictions/${playerId}`, { token })

export const submitPredictions = (inputs: PredictionInput[], token: string) =>
  apiFetch<{ ok: boolean; saved: number }>('/predictions', {
    method: 'POST',
    body: JSON.stringify({ predictions: inputs }),
    token,
  })
